import React from "react"
import api from "src/api"

export function useGetCategories() {
    const [dataCategories, setDataCategories] = React.useState([])
    const [categoryOptions, setCategoryOptions] = React.useState([])

    const [isLoading, setIsLoading] = React.useState(false)
    const [pagination, setPagination] = React.useState(null)

    React.useEffect(() => {
        getItems()
        getCategoryOptions()
    }, [])

    const getItems = async (page = 1, countOnPage = 20) => {
        setIsLoading(true)
        await api.get(`virtual-product-categories?page=${page}&countOnPage=${countOnPage}`).then(({ data }) => {
            setPagination({
                current: data.pagination.currentPage,
                pageSize: data.pagination.countOnPage,
                total: data.pagination.total,
            })
            const formatted = getFormattedItems(data.items)
            setDataCategories(formatted)
        })

        setIsLoading(false)
    }

    const getCategoryOptions = async () => {
        const { data } = await api.get(`virtual-product-categories?page=1&countOnPage=200&filters[0][t]=isNull&filters[0][f]=duplicate_product_category_id&filters[0][v]=null`)
        const options = data.items.filter((item) => !item.duplicateCategory).map((item) => ({
            value: item.id,
            label: item.name.find((n) => n.language === "ru")?.content ?? ""
        }))
        setCategoryOptions(options)
    }

    function handleTableChange(pagination) {
        getItems(pagination.current, pagination.pageSize)
    }

    function getFormattedItems(items) {
        const newItems = []

        items.forEach((item) => {
            let nameRu = item.name.find((n) => n.language === "ru")?.content ?? "";
            const productIds = item.products.map((element) => ({
                label: `${element.externalGuid} - ${element.short_name.find((name) => name.language === "ru")?.content ?? ""}`,
                value: element.id,
            }))
            const productsView = item.products.map((element) => element.short_name.find((name) => name.language === "ru")?.content ?? "")

            let newItem = {
                ...item,
                key: item.id,
                nameRu,
                productIds,
                productsView,
                duplicateProductCategoryId: item.duplicateCategory?.id ?? null,
                duplicateCategoryName: item.duplicateCategory
                    ? (item.duplicateCategory?.name.find((n) => n.language === "ru")?.content ?? `ID: ${item.duplicateCategory?.id}`)
                    : "Оригинальная категория"
            }
            newItems.push(newItem)
        })

        return newItems
    }

    return {
        dataCategories,
        pagination,
        isLoading,
        handleTableChange,
        refetch: () => getItems(),
        options: {categoryOptions}
    }
}
